import { styled as e } from "styled-components";
//#region src/components/ApiKeySecretPanel/ApiKeySecretPanel.styled.ts
var t = e.code`
    flex: 1;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    line-height: 1.6;
    word-break: break-all;
    padding: ${({ theme: e }) => e.spacing(1.5)};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.md};
    background: ${({ theme: e }) => e.colors.muted};
    color: ${({ theme: e }) => e.colors.foreground};
`;
//#endregion
export { t as SecretValue };
